import * as React from "react"
import { graphql } from "gatsby"
import Carousel from "../components/ui/carousel/Carousel"
import FlashSection from "../components/ui/section/FlashSection"
import Section from "../components/ui/section/Section"

const IndexPage = ({ data: { flashSale, sections } }) => {
  const flashImage = flashSale.image
  const allFlashSale = flashSale.products
  const slicedFlash = allFlashSale.slice(0, 8)
  const allSections = sections.subsections

  return (
    <>
      <section className="lg:p-12 p-4">
        <Carousel />
        <div className="divide-y-2 divide-primary space-y-6">
          {slicedFlash.length > 0 && (
            <FlashSection image={flashImage} category={slicedFlash} />
          )}
          {allSections.map(section => {
            return (
              <Section
                key={section._key}
                category={section.subcategory}
                products={section.products}
                image={section.image}
              ></Section>
            )
          })}
        </div>
      </section>
    </>
  )
}

export default IndexPage

export const query = graphql`
  {
    flashSale: sanityFlashSale {
      products {
        ...ProductCard
      }
      image {
        asset {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
    sections: sanitySection {
      subsections {
        _key
        image {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        subcategory {
          title
          slug {
            current
          }
          category {
            slug {
              current
            }
          }
        }
        products {
          ...ProductCard
        }
      }
    }
  }
`
